<template>
  <div>
    <div v-if="!!data.registro.transporte"
         class="col-12">
      <div class="row mt-2 mb-2 transporte">
        Existe Transporte - {{ 'Livro ' + data.registro.transporte.livro + ', fls. ' + data.registro.transporte.folha + '-' + data.registro.transporte.lado.toLowerCase() }}
      </div>
    </div>
    <div v-if="!data.registro.pessoa.cpf && dataMaxCPF()">
      <div class="col-12">
        <div class="row mt-2 mb-2 no-cpf">
          Registrado sem CPF
        </div>
      </div>
      <div class="col-12">
        <b-button class="btn btn-sm btn-primary white"
                  @click="gerarCPF(data.registro_id)">
          Gerar CPF
        </b-button>
      </div>
    </div>
    <div class="row mt-3 pl-3 pr-3 d-flex align-items-center justify-content-between">
      <div class="col-8">
        <div class="row">
          <div class="col-2">
            <label class="resumo-show_label ">
              CPF
              <icon-svg v-if="data.registro && data.registro.pessoa.cpf_origem == 'MANUAL'"
                        v-b-tooltip.hover.top="'Cadastrado manualmente'"
                        class="icon--xs"
                        icon="fileDocumentEdit" />
              <img v-if="data.registro && data.registro.pessoa.cpf_origem == 'CRC'"
                   v-b-tooltip.hover.top="'Gerado pela CRC'"
                   class="ResumoNascimentoDetalhes--crcIcon"
                   :src="crcLogoPrincipal">
            </label>
            <div class="resumo-show_sublabel">
              {{ data && data.registro && data.registro.pessoa.cpf | cpf }}
            </div>
          </div>

          <div class="col-3">
            <label class="resumo-show_label ">Nome</label>
            <div class="resumo-show_sublabel">
              {{ data && data.registro && data.registro.pessoa.nome }}
            </div>
          </div>

          <div class="col-3">
            <label class="resumo-show_label ">Data de nascimento</label>
            <div class="resumo-show_sublabel">
              {{ data && data.registro.pessoa.data_nascimento | date }}
            </div>
          </div>

          <div class="col-3">
            <label class="resumo-show_label ">Hora de nascimento</label>
            <div class="resumo-show_sublabel">
              {{ data && data.registro.hora_ocorrido | hour }}
            </div>
          </div>

          <div class="col-1 ResumoNascimentoDetalhes--sexo">
            <label class="resumo-show_label">Sexo</label>
            <div class="resumo-show_sublabel">
              {{ sexos[data.registro.pessoa.sexo] || 'Não informado' }}
            </div>
          </div>
        </div>
      </div>
      <div class="col-4">
        <div class="row">
          <div class="col-5">
            <Carga :prop-registro="data"
                   prop-tipo-registro="N"
                   :prop-data-carga="data_carga"
                   @reload="reload" />
          </div>
          <div class="col-7">
            <ExportarXML :prop-registro-id="data.registro_id" />
          </div>
          <div id="transporte-nascimento"
               class="col-5 mt-2">
            <button
              class="btn btn-outline-primary btn-block btn-sm"
              :disabled="!!data.registro.transporte"
              @click="gerarTransporte">
              Transporte
            </button>
          </div>
          <b-tooltip v-if="!!data.registro.transporte"
                     target="transporte-nascimento">
            Este registro já foi transportado.
          </b-tooltip>
          <div class="col-7 mt-2">
            <router-link :to="{ name: 'edicao_nascimento', params: { idNasc: data.nascimento_id, propNascimento: data } }"
                         class="btn btn-sm btn-primary btn-block editar">
              Editar
            </router-link>
          </div>
        </div>
      </div>
    </div>

    <div class="mt-2">
      <genitores-collapse v-if="data.registro.pessoa"
                          :genitores="data.registro.pessoa.genitores"
                          :collapse-visible="true"
                          :prop-nascimento="true" />

      <local-ocorrencia-collapse v-if="data.registro"
                                 :local="data.registro.local" />

      <gemeos-collapse v-if="data.registro.pessoa"
                       :gemeos="data.registro.pessoa.gemeos" />

      <partes-collapse v-if="data.registro"
                       :genitores="data.registro.pessoa.genitores"
                       :partes="data.registro.partes" />

      <collapse-default id="gestacao_parto"
                        :condition="data.nascimentoInformacao != undefined">
        <template v-slot:header>
          Gestação e Parto
        </template>

        <template v-slot:content>
          <div v-if="data.nascimentoInformacao"
               class="row p-2">
            <div class="col">
              <label class="resumo-show_label">
                Idade Mãe
              </label>
              <div class="resumo-show_sublabel">
                {{ data.nascimentoInformacao.idade_mae }}
              </div>
            </div>
            <div class="col">
              <label class="resumo-show_label">
                Qtd. Consultas Pré-Natal
              </label>
              <div class="resumo-show_sublabel">
                {{ data.nascimentoInformacao.total_consultas_pre_natal }}
              </div>
            </div>
            <div class="col">
              <label class="resumo-show_label">
                Semanas Gestação
              </label>
              <div class="resumo-show_sublabel">
                {{ data.nascimentoInformacao.total_semanas_gestacao }}
              </div>
            </div>
            <div class="col">
              <label class="resumo-show_label">
                Tipo Gravidez
              </label>
              <div class="resumo-show_sublabel">
                {{ data.nascimentoInformacao.tipo_gravidez }}
              </div>
            </div>
            <div class="col">
              <label class="resumo-show_label">
                Tipo Parto
              </label>
              <div class="resumo-show_sublabel">
                {{ data.nascimentoInformacao.tipo_parto }}
              </div>
            </div>
          </div>
        </template>
      </collapse-default>

      <recem-nascido-collapse v-if="data.recemNascido"
                              :recem-nascido="data.recemNascido" />

      <registro-collapse v-if="data.registro"
                         :prop-data="data" />
      <!-- <transporte-collapse v-if="!!data.registro.transporte"
                           :prop-data="data.registro.transporte" /> -->
    </div>
    <b-modal ref="modalCertificados"
             hide-footer
             title="Selecione um certificado"
             size="lg">
      <grid-certificados v-if="certificados && certificados.length > 0"
                         :certificados="certificados"
                         @onSelectCertificado="onSelectCertificado" />
    </b-modal>

    <MotivoAlteracao tipo="N"
                     @gravarAtualizacao="updateRegistro($event)" />

    <b-modal v-if="propNumeroPedidoPossueCertidaoEletronica"
             id="aviso-numero-pedido-possui-certidao-eletronica"
             size="md"
             hide-header
             hide-footer
             no-close-on-backdrop
             no-close-on-esc
             centered>
      <p class="mt-3">
        Já foi criada uma OS nº <strong style="font-size: 1.2rem;">{{ propPedidoPendente.numPedidoPossueOrdemServico.numero }}</strong> e gerada uma certidão eletrônica <a 
          :href="propPedidoPendente.numPedidoPossueCertidaoEletronica.link_assinatura"
          target="_blank" 
          rel="noopener noreferrer">
          <img 
            src="https://arpen-header-footer-prod.codebit.biz/assets/images/header/registro-civil-logo.svg" 
            alt="Abrir certidão eletrônica"
            style="height: 20px; vertical-align: middle;">
        </a> &nbsp; para o pedido nº <strong style="font-size: 1.2rem;">{{ propPedidoPendente.pedido_certidao_id }}</strong>.
      </p>
      <p>Deseja cumprir este pedido?</p>
      <div class="d-flex justify-content-end mt-4">
        <b-button
          class="btn-numero-pedido-possui-certidao-eletronica mr-3"
          @click="$bvModal.hide('aviso-numero-pedido-possui-certidao-eletronica'), $emit('fecharModalAvisoNumeroPedidoPossuiCertidaoEletronica', false, 'Sim')">
          Sim
        </b-button>
        <b-button
          style="background: #6c757d; border-color: #6c757d;"
          class="btn-numero-pedido-possui-certidao-eletronica"
          @click="$bvModal.hide('aviso-numero-pedido-possui-certidao-eletronica'), $emit('fecharModalAvisoNumeroPedidoPossuiCertidaoEletronica', false, 'Não')">
          Não
        </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
  /* assets */
  import icon_nascimento from "@/assets/icons/nascimento.svg?sprite"
  import crcLogoPrincipal from "@/assets/icons/CRC-logo_principal.svg"

  /* componentes */
  import GridCertificados from '../../../GridCertificados'
  import GenitoresCollapse from "../Collapses/GenitoresCollapse"
  import LocalOcorrenciaCollapse from "../Collapses/LocalOcorrenciaCollapse"
  import GemeosCollapse from "../Collapses/GemeosCollapse"
  import PartesCollapse from "../Collapses/PartesCollapse"
  import RecemNascidoCollapse from "../Collapses/RecemNascidoCollapse"
  import CollapseDefault from "../Collapses/CollapseDefault"
  import RegistroCollapse from "../Collapses/RegistroCollapse"
  import TransporteCollapse from "../Collapses/TransporteCollapse"
  import IconSvg  from "@/components/IconSvg"
  import MotivoAlteracao from '@/components/SofiaRei/Resumo/MotivoAlteracao.vue'
  import Carga from '../../Carga/Carga'
  import ExportarXML  from "@/components/ExportarXML"

  // services
  import BryService from "@/services/Assinaturas/BryService"
  import CpfGenerateService from "@/services/Registros/Nascimento/CpfGenerateService"
  import NascimentoService from "@/services/Registros/Nascimento"
  import RegistrosService from "@/services/Registros"

  //constants
  import objSwal from '@/constants/swalValues'

  // livraries
  import moment from "moment"
  import Swal from 'sweetalert2'

  /* filters */
  import { maskCPF } from "@/filters/filters"

  /* libraries */
  import {mapGetters} from "vuex"

  export default {
    name: "ResumoNascimentoDetalhes",
    components: {
      GenitoresCollapse,
      LocalOcorrenciaCollapse,
      GemeosCollapse,
      PartesCollapse,
      RecemNascidoCollapse,
      CollapseDefault,
      RegistroCollapse,
      TransporteCollapse,
      IconSvg,
      GridCertificados,
      MotivoAlteracao,
      Carga,
      ExportarXML
    },
    props: {
      data: { type: Object, default: ()=> ({}) },
      propPedidoPendente: {type: Object, default: () => {}},
      propNumeroPedidoPossueCertidaoEletronica: { type: Boolean, default: false}
    },
    data () {
      return {
        crcLogoPrincipal,
        certificados: [],
        certificadoSelecionado: null,
        icons: {
          icon_nascimento: icon_nascimento,
        },
        sexos: {
          'I': 'Indefinido',
          'M': 'Masculino',
          'F': 'Feminino',
        },
        registroId: null,
        data_carga: null,
        nodeEnv: process.env.NODE_ENV
      }
    },
    computed: {
      ...mapGetters({
        cartorioId: 'auth/getCartorioId'
      })
    },
    watch: {
      data () {
        this.getDataCarga()
      }
    },
    mounted () {
      this.getDataCarga()
    },
    methods: {
      async gerarCPF (registroId) {
        loader({ text: 'Validando extensão...', active: true })

        if (!this.data.numero_declaracao_nascido_vivo) {
          return displayMessage('error', 'Erro!', 'Informe o Nº Declaração Nascido Vivo.')
        }

        const validateExt = this.validateExtension()

        if (!validateExt) return

        loader({ text: 'Obtendo certificados...', active: true })

        this.certificados = await BryService.getCertificates()

        loader({ text: '', active: false })

        if (!this.certificados.length) {
          NProgress.done()
          objSwal.error.title = 'Erro'
          objSwal.error.text = 'Não foi possível selecionar o certificado'
          return Swal.fire(objSwal.error)
        }

        this.registroId = registroId

        if (this.certificados.length > 1) {
          this.$refs.modalCertificados.show()
        } else {
          this.certificadoSelecionado = this.certificados[0]

          // Anulando certificados obtidos
          this.certificados = null

          return this.assinarDocumento()
        }
      },

      onSelectCertificado (certificado) {
        this.certificadoSelecionado = certificado
        // Fechando modal
        this.$refs.modalCertificados.hide()
        // Anulando certificados obtidos
        this.certificados = null

        return this.assinarDocumento()
      },

      validateExtension () {
        const installed = BryService.isExtensionInstalled

        loader({ text: '', active: false })

        if (installed) return true

        objSwal.info.title = 'Extensão não instalada'
        objSwal.info.text = 'A extensão para assinatura digital não está instalada no seu navegador. Deseja instalar agora?'
        objSwal.info.confirmButtonText = 'Instalar'
        objSwal.info.showCancelButton = true
        objSwal.info.cancelButtonText = 'Não'

        return Swal.fire(objSwal.info).then(({ value }) => {
          if (value) {
            try {
              BryService.getExtension()
            } catch (e) {
              this.closeLoaderWithError('Erro', e.message)
            }
          }
        })
      },
      async assinarDocumento () {
        loader({ text: 'Assinando documento...', active: true })

        try {
          // Iniciamos a assinatura
          const start = await CpfGenerateService.startSigning(this.registroId, this.certificadoSelecionado.certificateData)
          const assinaturaInicializada = start.init.assinaturasInicializadas[0]

          // Pegamos o cifrado
          const signBase = await BryService.signBase64Content(
            this.certificadoSelecionado.certId, BryService.prepareContentForSignature(assinaturaInicializada.messageDigest, assinaturaInicializada.nonce))

          // A assinatura funciona como lote, aqui só assinamos 1 documento, entao coloco sempre no array.
          const documents = [{
            original: start.documents[0].document,
            signatureValue: signBase.assinaturas[0].hashes[0],
            file_name: start.documents[0].file_name,
            signedAttributes: start.init.assinaturasInicializadas[0].messageDigest
          }]

          // Finalizamos a assinatura
          const response = await CpfGenerateService.endSigning(this.registroId, start.init.nonce, this.certificadoSelecionado.certificateData, documents, signBase)
          this.changeCPF(response.cpfGerado)

          objSwal.success.title = ''
          objSwal.success.text = ''
          objSwal.success.html = `<p style="color: #000">O CPF nº <b>${maskCPF(response.cpfGerado) }</b> foi gerado com sucesso!</p>`

          NProgress.done()
          loader({ text: '', active: false })
          return Swal.fire(objSwal.success).then(() => {
            if (this.data.registro.existe_crc) this.showMotivoAlteracao()
            objSwal.success.html = ''
          }).finally(() => {
            objSwal.success.html = ''
          })
        } catch (error) {
          console.error(error)
          NProgress.done()
          loader({ text: '', active: false })

          objSwal.success.html = ''
          objSwal.error.title = 'Não foi possível realizar a assinatura'

          // Se o erro vier da API da bry
          if (error.description) {
            objSwal.error.text = `${JSON.stringify(error.description)}`
          }
          // Se vier da API do Barramento
          else if (error.response.data && error.response.data.message && error.response.data.message.message) {
            objSwal.error.text = `${JSON.stringify(error.response.data.message.message)}`
          }
          // Se vier da API do Sofia-rei
          else if (error.response.data && Array.isArray(error.response.data)) {
            const message = getErrors(error.response.data[0])

            objSwal.error.text = message.message
          }

          else {
            const message = getErrors(error)

            objSwal.error.text = message.message
          }

          if (objSwal.error.text && objSwal.error.text.match('CPF da pai')) {
            objSwal.error.text = objSwal.error.text.replace('CPF da pai', 'CPF do pai')
          }

          return Swal.fire(objSwal.error)
        } finally {
          this.registroId = null
          this.certificadoSelecionado = null
          this.$store.dispatch('auth/loader', { text: '', active: false }).then(()=> {})
        }
      },
      dataMaxCPF () {
        const data_registro = this.data.registro.data_registro
        const data_atual =  moment().format('YYYY-MM-DD')
        const data_limit = moment(data_registro).add(5, 'day').format('YYYY-MM-DD')

        if (data_atual > data_limit) return false
        else return true
      },
      changeCPF (cpf) {
        this.$emit('changeCPF', cpf)
      },
      displayError (title, text) {
        objSwal.error.title = title
        objSwal.error.text = text

        return Swal.fire(objSwal.error)
      },
      async updateRegistro ($event) {
        try {
          this.$root.$emit('bv::hide::modal', 'modalMotivoAlteracao')

          const { id } = this.$route.params

          this.data.registro.cod_motivo_alt = $event.codigo
          this.data.registro.data_averb_motivo_alt = $event.dataAverb

          loader({ text: '', active: true })

          const data = await NascimentoService.updateNascimento(id, this.data)

          //emite evento para atualizar os dados com o retorno da api
          this.$emit('updateNascimento', data)

          objSwal.success.title = `Registro atualizado com sucesso!`
          objSwal.success.text = ''

          return Swal.fire(objSwal.success)
        } catch (error) {
          this.displayError('Erro!', 'Não foi possível atualizar o registro.')
        } finally {
          loader({ text: '', active: false })
        }
      },
      showMotivoAlteracao () {
        this.$root.$emit('bv::show::modal', 'modalMotivoAlteracao')
      },
      getDataCarga () {
        if (!this.data.registro.data_carga) {
          this.data_carga = null
          return
        }

        const data = moment(this.data.registro.data_carga).format('DD/MM/YYYY')
        const hora = moment(this.data.registro.data_carga).format('H:mm').replace(':', 'h')

        this.data_carga = `Enviada ${data} ${hora}`
      },
      async reload () {
        try {
          loader({ text: "Carregando dados...", active: false })

          const { id } = this.$route.params

          const data = await NascimentoService.getNascimentoById(id)

          this.$emit('updateNascimento', data)

          this.getDataCarga()
        } catch (error) {
          console.error(error)
        } finally {
          loader({ text: "", active: false })
        }
      },

      async gerarTransporte () {
        const res = await displayMessage('question', 'Deseja realizar o transporte deste registro?')

        if (res.value) {
          try {
            loader({ text: "Gerando transporte...", active: true })

            const registro = this.data.registro

            await NascimentoService.transporte(registro)

            displayMessage('success','Transporte realizado com Sucesso!').then(() => {
              this.reload()
            })
          } catch (error) {
            const message = getErrors(error)
            return displayMessage('error', 'Erro!', message.message)
          } finally {
            loader({ text: "", active: false })
            
          }
        } 
      }

    }
  }
</script>

<style lang="scss">
  @import "../../../../scss/_components/resumos";
  .editar {
    fill: white
  }
  .white {
    fill: white
  }

  .no-cpf {
    background: #8B0000;
    color: #FFFFFF;
    padding: 2px;
    padding-left: 10px;
  }

  .ResumoNascimentoDetalhes {
    &--sexo {
      margin-left: -20px;
    }
    &--crcIcon {
      width: 35px;
    }
  }

  .transporte {
      background: #00bdc5 ;
      color: #FFFFFF;
      padding: 2px;
      padding-left: 10px;
  }

  .btn-numero-pedido-possui-certidao-eletronica {
    padding: 0.2rem 2rem;
    border-radius: 4px;
    font-size: 1rem;
  }
</style>
